/*
the way this works is heavily depend on the BACKEND (Yii) FORM!!!
*/

Blimp.Form = new Class({
	Extends: BlimpExt,

	options: {
		relocate: true,
		post_process_build: true,
		keep_form_on_success: false,
		replace_by_result: true,
		auto_hide_form: true,
		eventCategory: null,
		build: function(self){ //using this for the registration form outside of the blimp
			if(Blimp.Form.instances && Blimp.Form.instances.contains(self)){
				return;
			}
			self.parent();
			Blimp.Form.instances.include(self);
		}
	},

	build: function(){
		this.options.build(this);
	},

	post_process: function(){
		if(!this.added_signup){
			Core.add_signup_link(this._element.getElement('.reg_blimp'));
			this.added_signup = true;
		}
		this._form_wrapper = this._element.getElement('.w_form');
		if(this._form_wrapper){
			this._form = this._form_wrapper.getElement('form');
			if(this._form){
				this.build_form();
			}
		}
		if(this.options.post_process_build){
			this.parent();
		}

		this._flag = this._element.getElement('.flag');
		if (this._flag) {
			this._flag.show();
		}
	},

	submit: function(ev) {
		if (ev) {
			ev.stopPropagation();
			ev.preventDefault();
		}

		var self = this;
		window.crRecaptcha.execute(function(){ self.handle_form_submit()});

		// remove click callback
		this._form_wrapper.getElement(".button").removeEvents("click");
	},

	build_form: function(){
		var self = this;

		this._form.getElement('.button').addEvent('click', function(e) {
			this.remove_errors();
		}.bind(this));

		var _forgot_pw = this._form.getElement('.w_form_anchor.forgot');

		if(_forgot_pw){
			new Blimp.Form(_forgot_pw, {draggable: true});
		};
		
		Core.add_form_support(this._form, this.submit.bind(this), false, this.options.category, this.options.action, this.options.label);
	},

	remove_errors: function(){
		this._form.getElements('.form_item').each(function(e){ e.removeClass('_failed') });
		this._form.getElements('.validation-advice').each(function(e){ e.dispose(); });
	},

	handle_form_submit: function(){
		this.remove_errors();

		// trim the value of the field to remove extra s
		this._form.getElements('.form_item input[type=text]').each(function(_el){
			_el.value = _el.value.trim();
		});

		if(this.request && this.request.isRunning()){
			this.request.cancel();
		}

		var action_url = this.options.form_action || this._form.get('action') || this._link.get('data-rpc') ||this._link.get('href');

		if(!action_url){
			return;
		}

		var data = this._form.toQueryString().trim() + "&ajax=1" + "&" + window.crRecaptcha.getTokensStr("reCaptchaTokens");

		// track side contact submit
		if (this.options.eventCategory) {
			_gaq.push(['_trackEvent', this.options.eventCategory, 'submit', '']);
		}

		this.request = new Request.JSON({
			url: action_url,
			method: this._form.get('method') || 'post',
			data: data,
			onRequest: this.handle_form_request.bind(this),
			onSuccess: this.handle_form_success.bind(this),
			onFailure: this.handle_form_fail.bind(this)
		}).send();
	},

	handle_form_request: function(){
		if(this._element.getElement('.w_popup_loader'))
			this._element.getElement('.w_popup_loader').show();
		else
			this._element.addClass('_loading');

		this.fireEvent('formRequestStart', [this]);
	},

	handle_form_success: function(data){
		this.fireEvent('formRequestSuccess', [this, data]);

		if (this._form_wrapper.getElement("textarea")) {
			this._form_wrapper.getElement("textarea").set("value", "");
		}
		
		if(this._element.getElement('.w_popup_loader')) {
			this._element.getElement('.w_popup_loader').hide();
		} else {
			this._element.removeClass('_loading');
		}

		if (this._flag) {
			this._flag.hide();
		}

		var formname = this._form.getAttribute('data-formname') || this._form.getAttribute('data-id') || this._form.get('id');
		var id = this._form.getAttribute('data-id') || this._form.get('id');

		if((typeOf(data) == 'array' && data.length == 0) || (data[formname+'_FORMSUMMARY'] && data[formname+'_FORMSUMMARY'].length && data[formname+'_FORMSUMMARY'][0]['status'])){
			window.crRecaptcha.setSuccessState(true);

			// track
			var category = this.options.category || window.pageType;
			if (category && this.options.action) {
				_gaq.push(['_trackEvent', category, this.options.action, this.options.label]);
			}

			// track side contact success
			if (this.options.eventCategory) {
				_gaq.push(['_trackEvent', this.options.eventCategory, 'success', '']);
			}

			// track gtag
			if (data && data.RPCFormReusableContact_FORMSUMMARY
				&& data.RPCFormReusableContact_FORMSUMMARY[0]
				&& data.RPCFormReusableContact_FORMSUMMARY[0].status === true
				&& data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign) {
				crGtag.track(data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign.send_to, data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign.value);
			}

			// success
			this.fireEvent('formSuccess', [this, data]);
			if (site && site.page && site.page.$events) {
				// fire a event to the current page
				site.page.fireEvent('formSuccess', [this, data]);
			}

			if(data[formname+'_FORMSUMMARY'] && data[formname+'_FORMSUMMARY'].length && data[formname+'_FORMSUMMARY'][0]['message']){
				if(this.options.replace_by_result){
					this.replace_form(data, formname);
				}else{
					this.put_message(data, formname);
				}
			}

			if(data[formname+'_FORMSUMMARY'] && data[formname+'_FORMSUMMARY'].length && data[formname+'_FORMSUMMARY'][0]['redirectTo']){
				var url = data[formname+'_FORMSUMMARY'][0]['redirectTo'];
				window.location = (url == ''? window.location : data[formname+'_FORMSUMMARY'][0]['redirectTo']);
			}

			// For Google analytics tracking
			if(data[formname+'_FORMSUMMARY'] && data[formname+'_FORMSUMMARY'].length && data[formname+'_FORMSUMMARY'][0]['ga']){
				var ga = data[formname+'_FORMSUMMARY'][0]['ga'];
				crTrackerQueue.track(ga);
			}

			// NCR-4668, For Queue tracking
			if(data[formname+'_FORMSUMMARY'] && data[formname+'_FORMSUMMARY'].length && data[formname+'_FORMSUMMARY'][0]['trackQueue']){
				var trackQueue = data[formname+'_FORMSUMMARY'][0]['trackQueue'];
				crTrackerQueue.track(trackQueue);
			}

			if(data[formname+'_FORMSUMMARY'] && data[formname+'_FORMSUMMARY'].length && data[formname+'_FORMSUMMARY'][0]['script']){
				var js_script = data[formname+'_FORMSUMMARY'][0]['script'].stripScripts(function(script){
					js_script = script;
				});
				Browser.exec(js_script);
			}

			if(data[formname+'_FORMSUMMARY'] && data[formname+'_FORMSUMMARY'].length && data[formname+'_FORMSUMMARY'][0]['next']){
				// open the registration popup if "next" has a value
				var next_action = data[formname+'_FORMSUMMARY'][0]['next'];
				(function(){ this.open_registration_popup(next_action); }.delay(3000, this));
			}

			if(this.options.auto_hide_form)
				this.hide_delay = this.hide.delay(500000, this);

			if(this._link.hasClass('_autohide'))
				this._link.dispose();

		}else{
			window.crRecaptcha.setSuccessState(false);

			this.fireEvent('formFail', [this, data]);
			if (typeOf(data) == 'object' && Object.keys(data).length > 1) {
				let errors = [];
				if (data[formname+'_name'] && data[formname+'_name'][0].length > 0) {
					var _form = this._form;
					var _field = _form.getElement('#'+id+'_name');
					this.add_advice(_field, data[formname+'_name'][0]);
					errors.push('name');
				}

				if (data[formname+'_email'] && data[formname+'_email'][0].length > 0) {
					var _form = this._form;
					var _field = _form.getElement('#'+id+'_email');
					this.add_advice(_field, data[formname+'_email'][0]);
					errors.push('email');
				}
				if (data[formname+'_dayphone'] && data[formname+'_dayphone'][0].length > 0) {
					var _form = this._form;
					var _field = _form.getElement('#'+id+'_dayphone');
					this.add_advice(_field, data[formname+'_dayphone'][0]);
					errors.push('dayphone');
				}
				if (data[formname+'_terms_and_conditions']) {
					var _form = this._form;
					var _field = _form.getElement('#'+id+'_terms_and_conditions');
					this.add_advice(_field, data[formname+'_terms_and_conditions'][0]);
					errors.push('terms');
				}
				if (data[formname+'_password']) {
					var _form = this._form;
					var _field = _form.getElement('#'+id+'_password');
					this.add_advice(_field, data[formname+'_password'][0]);
					errors.push('password');
				}

				if (data[formname+'_first_name'] && data[formname+'_first_name'][0].length > 0) {
					var _form = this._form;
					var _field = _form.getElement('#'+id+'_first_name');
					this.add_advice(_field, data[formname+'_first_name'][0]);
					errors.push('firstname');
				}
				if (data[formname+'_phone'] && data[formname+'_phone'][0].length > 0) {
					var _form = this._form;
					var _field = _form.getElement('#'+id+'_phone');
					this.add_advice(_field, data[formname+'_phone'][0]);
					errors.push('phone');
				}
				if (data[formname+'_authorized'] && data[formname+'_authorized'][0].length > 0) {
					var _form = this._form;
					var _field = _form.getElement('#'+id+'_authorized');
					this.add_advice(_field, data[formname+'_authorized'][0]);
					errors.push('authorized');
				}
				if (data[formname+'_recaptcha'] && data[formname+'_recaptcha'][0].length > 0) {
					this.put_message(data, formname, 7000, "Recaptcha verification failed. Please refresh the page and try again.");

					errors.push(data[formname+'_recaptcha'][0]);
				}

				// track side contact field error
				if (this.options.eventCategory) {
					_gaq.push(['_trackEvent', this.options.eventCategory, 'validation error', errors.join(',')]);
				}
			} else {//Backend error, It will go here only when something wrong happened in the server that caused of not saving the email
				if(this.options.replace_by_result){
					var _success = this._element.getElement('.w_popup_success')

					if(_success){
						_success.set('html', data[formname+'_FORMSUMMARY'][0]['message']);
						_success.addClass('_failed');
						_success.show();
						(function(){ _success.hide(); }).delay(3000);

					}
				}else{
					this.put_message(data, formname);
				}

				// track side contact bed error
				if (this.options.eventCategory) {
					_gaq.push(['_trackEvent', this.options.eventCategory, 'system error', data[formname+'_FORMSUMMARY'][0]['message']]);
				}
			}
		}
	},
	replace_form: function(data, id){
		var self = this;
		var _success = this._element.getElement('.w_popup_success');


		if(_success){
			_success.set('html', data[id+'_FORMSUMMARY'][0]['message']);
			_success.removeClass('_failed');
			_success.show();
			_success.addClass('visible');
		}

		this.fireEvent('successShow');

		var self = this;

		if(!this.options.auto_hide_form){

			(function(){
				_success.hide();
				self.fireEvent('successHide');

			}).delay(3000);
		}

	},
	put_message: function(data, id, delay, message){
		if (typeof(delay) === "undefined") {
			delay = 3000;
		}
		if (typeof(message) === "undefined") {
			message = data[id+"_FORMSUMMARY"][0]["message"];
		}

		var _success_message = new Element('.' + this.options.cls+'_success_message', {'html': message});

		var _header = this._element.getElement('.tk_header');
		if(_header) {
			_header.hide();
		}

		if(this.options.keep_form_on_success){

			_success_message.inject(this._form_wrapper, 'before');

			(function(){
				var _parent = _success_message.getParent('.contact._active');

				if(_parent){
					_parent.removeClass('_active');
				}

				_success_message.dispose();
			}).delay(delay);

			var _msg = this._element.getElement('.w_msg');
			if(_msg){
				_msg.dispose();
			}

			return;

		}else{
			if(this._form_wrapper){
				_success_message.replaces(this._form_wrapper);

				var _email_us = _success_message.getElement('.w_blimp_contact_us');

				if(_email_us){
					 new Blimp.Form(_email_us, {draggable: true});
				};
			}else{
				var _body = this._element.getElement('.'+this.options.cls+'_body');
				if(_body){

					_body.set('html', _success_message);
				}else{
					this._element.set('html', _success_message);
				}
			}
		}
		this.fireEvent('message');
	},

	handle_form_fail: function(){
		window.crRecaptcha.setSuccessState(false);

		if (this._element.getElement('.w_popup_loader')) {
			this._element.getElement('.w_popup_loader').hide();
		} else {
			this._element.removeClass('_loading');
		}
		this.remove_errors();
		this.fireEvent('formRequestFail', [this]);

		// track side contact success
		if (this.options.eventCategory) {
			_gaq.push(['_trackEvent', this.options.eventCategory, 'system error', '']);
		}
	},

	hide: function(){
		this.parent();

		var _success = this._element? this._element.getElement('.w_popup_success') : null;
		if(_success) _success.hide();

		clearTimeout(this.hide_delay);
	},

	show: function(){
		this.parent();

		if(Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android') return;
	},

	open_registration_popup: function(next_action){
		Signup_blimp._link.fireEvent('click');

		var form_json = JSONMOO.encode(this._form.toQueryString().parseQueryString());
		form_json = JSONMOO.decode(form_json, false);
		var full_name = form_json['RPCFormReusableContact[name]'];
		var first_name = full_name.substring(0, full_name.lastIndexOf(' ')).trim();
		var last_name = full_name.contains(' ')? full_name.substring(full_name.lastIndexOf(' ')).trim() : '';
		var email = form_json['RPCFormReusableContact[email]'];
		var _inputs = Signup_blimp._element.getElements('input[type="text"], input[type="password"]');

		//clear field
		_inputs.each(function(_el){
			_el.value = '';
		});

		if(next_action == 'signin'){
			Signup_blimp._element.getElement('.signin_toggle').fireEvent('click');
			Signup_blimp._element.getElement('#RPCFormLogin_email').value = email;
			Signup_blimp._element.getElement('#RPCFormLogin_password').focus();
		}
		else{
			Signup_blimp._element.getElement('.signup_toggle').fireEvent('click');
			Signup_blimp._element.getElement('#FormRegistrationPopup_first_name').value = first_name || full_name;
			Signup_blimp._element.getElement('#FormRegistrationPopup_last_name').value = last_name;
			Signup_blimp._element.getElement('#FormRegistrationPopup_email').value = email;
			Signup_blimp._element.getElement('#FormRegistrationPopup_password').focus();
		}
	},

	add_advice: function(_field, generic_message) {
		if (_field) {
			var _li = _field.getParent('li') || new Element('div');
			var _advice = _field.getNext('.validation-advice') || new Element('div', {'class': 'validation-advice'}).inject(_field, 'after');
			var msg = _field.get('data-error-exists') || generic_message;
			_li.addClass('_failed');
			_field.addClass('validation-failed');

			_advice.set('html', msg).show();
		}
	}
});

Blimp.Form.instances = [];
